import React, { useState, useRef } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Button } from 'primereact/button';
import Input from 'react-phone-number-input/input'
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import config from '../config';
const Add_client = ({ onSuccess }) => {
    const { accessToken } = useAuth();
    const [value, setValue] = useState('');
    // State for form fields
    const [formData, setFormData] = useState({
        CompanyName: '',
        email: '',
        phone: '',
        billingName: '',
        poc: '',
        gstin: '',
        pan: '',
        address1: '',
        address2: '',
        city: '',
        zip: '',
        country: '',
        state: '',
    });

    const [loading, setLoading] = useState(false);
    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle phone number input separately
    const handlePhoneChange = (value) => {
        setFormData((prev) => ({ ...prev, phone: value }));
    };


    // Submit form
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Combine address fields into a single string
        const fullAddress = `${formData.address1}, ${formData.address2}, ${formData.city}, ${formData.state}, ${formData.zip}, ${formData.country}`;

        const payload = {
            billingName: formData.CompanyName,
            email: formData.email,
            phone: formData.phone,
            comp_name: `${formData.CompanyName}`,
            bill_name: formData.billingName,
            poc: formData.poc,
            gstin: formData.gstin,
            pan: formData.pan,
            bill_address: fullAddress,
        };

        try {
            const response = await axios.post(
                `${config.apiBASEURL}/ClientRoutes/add-client`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            onSuccess();
            setFormData({
                CompanyName: '',
                email: '',
                phone: '',
                billingName: '',
                poc: '',
                gstin: '',
                pan: '',
                address1: '',
                address2: '',
                city: '',
                zip: '',
                country: '',
                state: '',
            });
        } catch (error) {
            console.error('Error adding client:', error.response || error);
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            <Form onSubmit={handleSubmit}>
                <Row className='mx-0 px-2' style={{ height: '65vh', overflowY: 'auto' }}>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>Company Name <span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="CompanyName"
                            value={formData.CompanyName}
                            onChange={handleChange}
                            required
                        />
                    </Col>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>Email <span className='text-danger'>*</span></label>
                        <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </Col>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>Phone No. <span className='text-danger'>*</span></label>
                        <PhoneInput
                            defaultCountry="IN"
                            value={formData.phone}
                            onChange={handlePhoneChange}
                            international
                            className="w-100 from-control"
                            required
                        />
                    </Col>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>Billing Name <span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="billingName"
                            value={formData.billingName}
                            onChange={handleChange}
                            required
                        />
                    </Col>
                    <Col lg={4} md={6} className="mb-3 px-1">
                        <label>Point of Contact <span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="poc"
                            value={formData.poc}
                            onChange={handleChange}
                            required
                        />
                    </Col>
                    <Col lg={4} md={6} className="mb-3 px-1">
                        <label>GSTIN <small className='text-warning' style={{fontSize:'10px', letterSpacing:'0.5px'}}>(Optional)</small></label>
                        <Form.Control
                            type="text"
                            name="gstin"
                            value={formData.gstin}
                            onChange={handleChange}
                        />
                        
                    </Col>
                    <Col lg={4} md={6} className="mb-3 px-1">
                        <label>PAN <small className='text-warning' style={{fontSize:'10px', letterSpacing:'0.5px'}}>(Optional)</small></label>
                        <Form.Control
                            type="text"
                            name="pan"
                            value={formData.pan}
                            onChange={handleChange}
                            
                        />
                    </Col>
                    <Col lg={12} md={12} className="px-1">
                        <h6 className='py-3 mb-3 text-black'>Billing Address</h6>
                    </Col>
                    <Col lg={12} md={12} className="mb-3 px-1">
                        <label>Appartment, Building, Suite, etc. <span className='text-danger'>*</span> </label>
                        <Form.Control
                            type="text"
                            name="address1"
                            value={formData.address1}
                            onChange={handleChange}
                            maxLength={15} // Adds a max limit
                            required
                        />
                        <small className='text-muted' style={{fontSize:'11px'}}>(Max 15 characters)</small>
                    </Col>
                    <Col lg={12} md={12} className="mb-3 px-1">
                        <label>Street, Area, Locality, etc. <span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="address2"
                            value={formData.address2}
                            onChange={handleChange}
                            maxLength={40} // Adds a max limit
                            required
                        />
                        <small className='text-muted' style={{fontSize:'11px'}}>(Max 40 characters)</small>
                    </Col>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>City<span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            maxLength={20} // Adds a max limit
                            required
                        />
                        <small className='text-muted' style={{fontSize:'11px'}}>(Max 20 characters)</small>
                    </Col>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>Pin / Zip Code <span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="zip"
                            value={formData.zip}
                            onChange={handleChange}
                            maxLength={10} // Adds a max limit
                            required
                        />
                        <small className='text-muted' style={{fontSize:'11px'}}>(Max 10 characters)</small>
                    </Col>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>Country<span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                            maxLength={20} // Adds a max limit
                            required
                        />
                        <small className='text-muted' style={{fontSize:'11px'}}>(Max 20 characters)</small>
                    </Col>
                    <Col lg={6} md={6} className="mb-3 px-1">
                        <label>State<span className='text-danger'>*</span></label>
                        <Form.Control
                            type="text"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                            maxLength={15} // Adds a max limit
                            required
                        />
                        <small className='text-muted' style={{fontSize:'11px'}}>(Max 15 characters)</small>
                    </Col>
                    <Col lg={12} md={12} className="px-1 text-end mt-3 mb-3">
                        <Button
                            label={loading ? 'Saving...' : 'Save'}
                            className='border-0 py-2'
                            severity='info'
                            icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
                            type="submit"
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Form>
        </>
    );
};
export default Add_client